import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Company } from '../../services';

export type CompanyState = {
  companies: Company[];
  selectedCompany: Company | null;
  setSelectedCompany: (company: Company) => void;
  setCompanies: (companies: Company[]) => void;
};

const useCompanyStore = create(
  persist<CompanyState>(
    set =>
      ({
        companies: [],
        selectedCompany: null,
        setSelectedCompany: (company: Company) =>
          set({
            selectedCompany: company,
          }),
        setCompanies: (companies: Company[]) =>
          set({
            companies,
          }),
      } as CompanyState),
    {
      name: '@tenGovUseCompanyStore',
    },
  ),
);

export default useCompanyStore;
